var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated-counter-component"},[_vm._v(" "+_vm._s(_vm.animatedNumber)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }